import React from 'react';
import { productImage, purchaseAnchor } from './constants';
interface ProductImageProps {
  className?: string;
}
export function ProductImage({
  className = 'max-w-[280px]'
}: ProductImageProps) {
  return <a href={purchaseAnchor} className="block" data-id="element-116" data-mp="2ll7w1qu0alpw">
      <img src={productImage} alt="Rhythmic Gym Pro — Sistema Completo 6-in-1 per Allenatori di Ginnastica Ritmica" className={`w-full h-auto object-contain mx-auto drop-shadow-xl ${className}`} data-id="element-117" data-mp="2ljwsns4h3fzb" />
    </a>;
}